import { Node, mergeAttributes } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'
import ButtonNodeView from './ButtonNodeView'

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    postButton: {
      insertButton: () => ReturnType
    }
  }
}

export const ButtonExtension = Node.create({
  name: 'postButton',
  group: 'block',
  atom: true,

  addAttributes() {
    return {
      text: { default: '' },
      url: { default: '' },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'a[data-post-button]',
        getAttrs: (dom) => {
          if (typeof dom === 'string') return false
          return {
            url: dom.getAttribute('href') || '',
            text: dom.textContent || '',
          }
        },
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'a',
      mergeAttributes(
        {
          'data-post-button': '',
          href: HTMLAttributes.url,
          target: '_blank',
          rel: 'noopener noreferrer',
          style:
            'display:block;text-align:center;padding:12px 24px;background:#2563eb;color:#fff;border-radius:8px;text-decoration:none;font-weight:500;margin:8px 0;',
        },
        {}
      ),
      HTMLAttributes.text || '',
    ]
  },

  addNodeView() {
    return ReactNodeViewRenderer(ButtonNodeView)
  },

  addCommands() {
    return {
      insertButton:
        () =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: { text: '', url: '' },
          })
        },
    }
  },
})

export default ButtonExtension
